<template>
	<v-fab-transition>
		<v-btn
			color="dark"
			dark
			fixed
			bottom
			right
			fab
			@click="$emit('click')"
			style="margin-bottom: 30px; margin-right: 5px"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>
	</v-fab-transition>
</template>

<script>
export default {};
</script>